import { useEffect, useState, useRef, useCallback } from "react";
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import { Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/grid';
import _ from 'lodash';

export default function Review(props) {
    const { t, slidesList, tabName, openModal, setSlideIndex, setVideoIndex, slideNumber } = props;
    const swiper = useSwiper();
    const [initialSlideIndex, setInitialSlideIndex] = useState(1);
    const [swiperControl, setSwiperControl] = useState({});

    const containerRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);

    /*
    const handleMouseDown = (event) => {
        setIsDragging(true);
        setStartX(event.clientX - containerRef.current.offsetLeft);
        setScrollLeft(containerRef.current.scrollLeft);
    };
    */

    const handleMouseDown = useCallback((event) => {
        setIsDragging(true);
        setStartX(event.clientX - containerRef.current.offsetLeft);
        setScrollLeft(containerRef.current.scrollLeft);

        document.addEventListener(
            "mouseup",
                () => {
                    setIsDragging(false);
                },
                { once: true }
            );
        }, []);

    const handleMouseMove = (event) => {
        if (!isDragging) return;
        const x = event.clientX - containerRef.current.offsetLeft;
        const scrollX = x - startX;
        containerRef.current.scrollLeft = scrollLeft - scrollX;
    };

    /*
    const handleMouseUp = () => {
        setIsDragging(false);
    };
    */

    return (
        <>
            <style dangerouslySetInnerHTML={{ __html: `
                .loading-speed ul li:first-child {
                    border-top-left-radius: 10px;
                    border-bottom-left-radius: 10px;
                }

                .loading-speed ul li:last-child {
                    border-top-right-radius: 10px;
                    border-bottom-right-radius: 10px;
                }
            ` }}></style>

            <div className="loading-speed">
                <Swiper
                    className={"swiper-container-"+slideNumber}
                    modules={[Navigation]}
                    onSlideChange={(swiper) => setInitialSlideIndex(swiper.activeIndex + 1)}
                    onSwiper={() => console.log('')}
                    navigation={{
                        nextEl: ".swiper-button-next-"+slideNumber,
                        prevEl: ".swiper-button-prev-"+slideNumber,
                    }}
                    onInit={(event) => {
                        setSwiperControl(event);
                    }}
                >
                    <div className="swiper-wrapper">
                        {
                            slidesList.length > 0 ?
                                _.reduce(slidesList, function(result, value, key) {
                                    result.push(<div className="swiper-slide" key={key}>
                                        <SwiperSlide key={key}>
                                            <span><img src={`${process.env.NEXT_PUBLIC_FS_URL}${value.icon}`}  alt="" className="img-fluid" style={{ maxWidth: '80px' }}/></span>
                                            <div className="text-inner">
                                                <h4>{value.slide_name}</h4>
                                                <p dangerouslySetInnerHTML={{ __html: value.text_content }} />
                                                <a onClick={() => { openModal(), setSlideIndex(slideNumber), setVideoIndex(key) }} style={{ cursor: 'pointer', color: '#bb9b6a' }}>
                                                    <img src="/assets/images/video-icon.svg" alt="" style={{ paddingRight: '15px', maxWidth: '60px' }} />{t('Watch_video')}
                                                </a>
                                            </div>
                                            <div className="swiper-counter">
                                                <span className="count">{initialSlideIndex}</span>/<span className="total">{slidesList.length}</span>
                                            </div>
                                        </SwiperSlide>
                                    </div>)
                                    return result;
                                },[])
                                :
                                null
                        }
                    </div>
                </Swiper>
                <div className={"swiper-button-prev swiper-button-prev-"+slideNumber}></div>
                <div className={"swiper-button-next swiper-button-next-"+slideNumber}></div>
                <div className="table-responsive">
                    <div className="d-flex justify-content-md-center">
                        <ul className={`loading-swiper bg-transparent ${tabName.length <= 1 ? 'justify-content-center' : ''}`}
                            ref={containerRef}
                            onMouseDown={handleMouseDown}
                            onMouseMove={handleMouseMove}
                            // onMouseUp={handleMouseUp}
                        >
                            {_.reduce(tabName, function(result, value, key) {
                                result.push(
                                    <li style={{ backgroundColor: initialSlideIndex == key + 1 ? '' : 'white', cursor: 'pointer' }} key={key} className={ `${initialSlideIndex == key + 1 ? 'active' : ''}` } onClick={ ()=> { swiperControl.slideTo(key) } }>{value}</li>
                                )
                                return result;
                            }, [])}
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}